import { render, staticRenderFns } from "./detailProcecss.vue?vue&type=template&id=ae75b4f4&scoped=true"
import script from "./detailProcecss.vue?vue&type=script&lang=js"
export * from "./detailProcecss.vue?vue&type=script&lang=js"
import style0 from "./detailProcecss.vue?vue&type=style&index=0&id=ae75b4f4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae75b4f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae75b4f4')) {
      api.createRecord('ae75b4f4', component.options)
    } else {
      api.reload('ae75b4f4', component.options)
    }
    module.hot.accept("./detailProcecss.vue?vue&type=template&id=ae75b4f4&scoped=true", function () {
      api.rerender('ae75b4f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/examine/components/detailProcecss.vue"
export default component.exports